import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Row, Tooltip, Typography, Button } from 'antd';
import CartBudgetStyleHolder from '../../../../components/Styles/cartBudgetStyle';
import NumberFormat from '../../../../components/NumberFormat';
import { spots } from '../services/investmentCalculations';
import { getDomain } from '../../../../services/utils';
import HiddenByCpmTypeContainer from '../../../shared/containers/HiddenByCpmTypeContainer';

const { Text, Title } = Typography;

const CartBudgetComponent = ({
  stepsCurrent,
  updateByAmountBudget,
  amountBudget,
  realAmount,
  currentCampaign,
  isPaymentStatusApproved,
  editCampaignActive,
  currency,
  customContents,
  cart,
  updateRealAmount,
  campaignCurrency
}) => {
  const { t } = useTranslation();
  const [calculatedBudget, setCalculatedBudget] = useState(0);
  const [currentCurrency, setCurrentCurrency] = useState(currency);
  const domain = getDomain(window.location.hostname);

  const isDifferentMount = () => {
    const amountBudgetAux = Number(amountBudget);
    if (calculatedBudget > amountBudgetAux) return true;
    if (calculatedBudget <= amountBudgetAux * 0.9) return true;
    return false;
  };

  useEffect(() => {
    var newAmount = 0;
    customContents.forEach(relation => {
      let cartSelect = null;
      let cpm = 0;
      if (editCampaignActive && currentCampaign.payment_status === 'approved') {
        // If add new display when editing campaign => cartSelect === null
        cartSelect = currentCampaign.contents_displays.find(
          item => item.display_id === relation.displayId && item.cpm !== 0
        );
        cpm = !!cartSelect ? cartSelect.cpm : relation.smart_campaign_cpm;
      } else {
        cartSelect = cart.find(display => display.id === relation.displayId);
        cpm = cartSelect && cartSelect.smart_campaign_cpm;
      }

      if (!cartSelect) return;
      const promisedShows = relation.promised_shows;
      newAmount = newAmount + spots.toBudget(promisedShows, cpm);
    });

    if (newAmount !== realAmount && newAmount) {
      updateRealAmount(newAmount);
    }

    if (!newAmount) updateRealAmount(realAmount);
  }, []);

  useEffect(() => {
    setCalculatedBudget(Math.round(realAmount * 100) / 100);
    setCurrentCurrency(editCampaignActive ? campaignCurrency : currency);
    isDifferentMount();
  }, [realAmount, currency]);

  return (
    <CartBudgetStyleHolder>
      <div className="cartBudget">
        <Row type="flex" justify="space-between">
          <Title level={3} className="text-title">
            {t('Tight budget')}
            <Tooltip
              placement="right"
              title={
                <HiddenByCpmTypeContainer
                  fallback={t(
                    'You can configure the spots per screen and see how the adjusted budget varies depending on the impact you want._cpmi'
                  )}
                >
                  {t(
                    'You can configure the spots per screen and see how the adjusted budget varies depending on the impact you want.'
                  )}
                </HiddenByCpmTypeContainer>
              }
            >
              <Icon type="question-circle" theme="outlined" style={{ marginLeft: '5px' }} />
            </Tooltip>
          </Title>
        </Row>
        <Row>
          <div className={`content-info ${domain === 'dv360' ? 'dv360' : ''}`} style={{ marginTop: '3px' }}>
            <Text>
              <NumberFormat
                value={calculatedBudget === 0 ? amountBudget : calculatedBudget}
                currency={currentCurrency}
              />
              <span style={{ fontSize: '10px' }}> + imp</span>
            </Text>
            {isDifferentMount() && stepsCurrent !== 0 && !isPaymentStatusApproved && (
              <Tooltip
                placement="right"
                title={t('The initial amount was modified; you can redistribute the budget')}
              >
                <Icon
                  type="exclamation-circle"
                  theme="outlined"
                  style={{ color: '#fadb14eb', fontSize: '18px', marginLeft: '5px' }}
                />
              </Tooltip>
            )}
          </div>
        </Row>
        <Row style={{ textAlign: 'center' }}>
          {stepsCurrent !== 0 && !isPaymentStatusApproved && (
            <Tooltip
              className="appear-animation-without-movement"
              placement="right"
              title={
                <HiddenByCpmTypeContainer
                  fallback={t(
                    'For each screen it will equalize the investment and recalculate the spots (changes you have made to spots for each ad or screen will be erased)_cpmi'
                  )}
                >
                  {t(
                    'For each screen it will equalize the investment and recalculate the spots (changes you have made to spots for each ad or screen will be erased)'
                  )}
                </HiddenByCpmTypeContainer>
              }
            >
              <Button
                className="groupFilterButton"
                onClick={() => updateByAmountBudget(realAmount)}
                style={{ marginBottom: '5px' }}
              >
                <span className="balanceButtonText">{t('Balance $')}</span>
              </Button>
            </Tooltip>
          )}
        </Row>
      </div>
    </CartBudgetStyleHolder>
  );
};

export default CartBudgetComponent;
